// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cheatsheet {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50px;
  padding: 5px 10px;
  margin-left: -15px;
  z-index: 5;
}
.cheatsheet .row {
  padding-bottom: 5px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
